<div class="wrapper">
    <router-outlet></router-outlet>
</div>
<app-dialog-host></app-dialog-host>
